import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
	totalCount: number;
	intercomLink: string;
}

const OpenInIntercom = ({ totalCount, intercomLink }: Props) => {
	const { t } = useTranslation("admin");
	const styles = {
		fontWeight: 600,
		fontSize: "10px",
		background: "#DCE6F5",
		height: "14px",
		borderRadius: "6px",
		padding: "4px",
	};
	const countInfo = <span style={styles}>{totalCount}</span>;

	return (
		<a href={intercomLink} className="ms-auto btn btn-add" target="_blank" rel="noreferrer">
			{t("modules.organization.action.open_in_intercom.title")} {totalCount ? countInfo : null}
		</a>
	);
};

export default OpenInIntercom;
